/*Common containers that have styles used across the app*/

import SideBannerContainer from './SideBannerContainer';

export { SideBannerContainer };
